import { AxiosRequest } from 'src/lib/axios/Axios';
import { ImportPricesPayload, ImportPricesResult } from './types';

export const importPrices = async (payload: ImportPricesPayload): Promise<ImportPricesResult> => {
  const response = await AxiosRequest.post<ImportPricesResult>('/publications/import-prices', payload);
  return response.data;
};
